import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HomeComponent } from "./component/home.component";
import { RegisterComponent } from "./component/register.component";
import { ActivationComponent } from "./component/activation.component";
import { LoginComponent } from "./component/login.component";
import { AboutComponent } from "./component/about.component";
import { TOUComponent } from "./component/tou.component";
import { DisclaimerComponent } from "./component/disclaimer.component";
import { KilowantUComponent } from "./component/kilowant-u.component"
import { PrivacyPolicyComponent } from "./component/privacy-policy.component";
import { UserHomeComponent } from "./component/user-home.component";
import { FAQComponent } from "./component/faq.component";
import { OurStoryComponent } from "./component/our-story.component";
import { ForgotPasswordComponent } from "./component/forgot-password.component";
import { LoginSetupComponent } from "./component/login-setup.component";
import { UserDetailsComponent } from "./component/user-details.component";
import { ClientListComponent } from "./component/advisor/client-list.component";
import { ClientDetailsComponent } from "./component/advisor/client-details.component";
import { AccountListComponent } from "./component/account-list.component";
import { AccountAddComponent } from "./component/account-add.component";
import { BuyOfferListComponent } from "./component/buy-order-list.component";
import { BuyOfferAddComponent } from "./component/buy-order-add.component";
import { ContractListComponent } from "./component/contract-list.component";
import { ExistingContractDetailsComponent } from "./component/existing-contract-details.componet";

import { AITaskListComponent } from "./component/ai-task-list.component";

import { SellerHomeComponent } from "./component/seller/seller-home.component";
import { SellerHomeSellOfferComponent } from "./component/seller/seller-sell-offers.component";
import { SellerHomeBuyOfferComponent } from "./component/seller/seller-buy-offers.component";
import { SellerHomeAcceptedOfferComponent } from "./component/seller/seller-accepted-offers.component";
import { SellerFeesComponent } from "./component/seller/seller-fees.component";

import { SellerAccountComponent } from "./component/seller/seller-account.component";
import { SellerUtilitiesComponent } from "./component/seller/seller-utilities.component";
import { SellerTermsListComponent } from "./component/seller/seller-terms-list.component";
import { SellerVerifyContractComponent } from "./component/seller/seller-verify-contract.component";
import { SellerViewContractComponent } from "./component/seller/seller-view-contract.component";
import { SellerBulkImportComponent } from "./component/seller/seller-bulk-import.component";
import { BuyOfferDetailsComponent } from "./component/buy-offer-details.component";
import { SellOfferDetailsComponent } from "./component/selloffer-details.component";
import { SellerBatchExportListComponent } from "./component/seller/seller-batch-export.component";

import { ViewContractComponent } from "./component/view-contract.component";
import { PreRegisterComponent } from "./component/pre-register.component";

export const routes: Routes = [
    {
        path: "user/registration",
        title: "Create Account | Kilowant",
        component: RegisterComponent
    },
    {
        path: "user/activation",
        title: "Activate Account | Kilowant",
        component: ActivationComponent
    },
    {
        path: "about",
        title: "About | Kilowant",
        component: AboutComponent
    },
    {
        path: "user/login",
        title: "Sign In | Kilowant",
        component: LoginComponent
    },
    {
        path: "user/logout",
        title: "Sign Out | Kilowant",
        component: LoginComponent
    },
    {
        path: "tou",
        title: "Terms of Use | Kilowant",
        component: TOUComponent
    },
    {
        path: "disclaimer",
        title: "Disclaimer | Kilowant",
        component: DisclaimerComponent
    },
    {
        path: "user/kilowant-u",
        title: "Kilowant University | Kilowant",
        component: KilowantUComponent
    },
    {
        path: "user/faq",
        title: "FAQ | Kilowant",
        component: FAQComponent
    },
    {
        path: "faq",
        title: "FAQ | Kilowant",
        component: FAQComponent
    },
    {
        path: "our-story",
        title: "Our Story | Kilowant",
        component: OurStoryComponent
    },    
    {
        path: "privacy-policy",
        title: "Privacy Policy | Kilowant",
        component: PrivacyPolicyComponent
    },
    {
        path: "user/forgot-password",
        title: "Forgot Password | Kilowant",
        component: ForgotPasswordComponent
    },
    {
        path: "user/login-setup",
        title: "Set Up Sign In | Kilowant",
        component: LoginSetupComponent
    },
    {
        path: "user/home",
        title: "My Kilowant | Kilowant",
        component: UserHomeComponent
    },
    {
        path: "user/details",
        title: "My Details | Kilowant",
        component: UserDetailsComponent
    },

    {
        path: "client/list",
        title: "Clients | Kilowant",
        component: ClientListComponent
    },
    {
        path: "client/details/:id",
        title: "Client Details | Kilowant",
        component: ClientDetailsComponent
    },
    {
        path: "client/add",
        title: "Add Client | Kilowant",
        component: ClientDetailsComponent
    },

    {
        path: "account/list",
        title: "Accounts | Kilowant",
        component: AccountListComponent
    },
    {
        path: "account/details/:id",
        title: "Account Details | Kilowant",
        component: AccountAddComponent
    },
    {
        path: "account/add",
        title: "Add Account | Kilowant",
        component: AccountAddComponent
    },
    {
        path: "account/init",
        title: "Get Started | Kilowant",
        component: PreRegisterComponent
    },
    {
        path: "account/onboarding",
        title: "Account Setup | Kilowant",
        component: AccountAddComponent
    },
    {
        path: "account/onboarding/:id",
        title: "Account Setup | Kilowant",
        component: AccountAddComponent
    },
    {
      path: "priceplans/list",
      title: "Price Plans | Kilowant",
        component: ContractListComponent
    },
    {
      path: "priceplans/details/:id",
      title: "Price Plan Details | Kilowant",
        component: ExistingContractDetailsComponent
    },
    {
      path: "priceplans/details",
      title: "Price Plan Details | Kilowant",
        component: ExistingContractDetailsComponent
    },

    {
        path: "ai-task/list",
        title: "AI Tasks | Kilowant",
        component: AITaskListComponent
    },
    {
        path: "seller/home",
        title: "Supplier Home | Kilowant",
        component: SellerHomeComponent,
        children: [
            {
                path: "sell-offers",
                title: "Sell Offers | Kilowant",
                component: SellerHomeSellOfferComponent
            },
            {
                path: "buy-offers",
                title: "Buy Offers | Kilowant",
                component: SellerHomeBuyOfferComponent
            },
            {
                path: "accepted-offers",
                title: "Accepted Offers | Kilowant",
                component: SellerHomeAcceptedOfferComponent
            }
        ]
    },
    {
        path: "seller/my-account",
        title: "Supplier Account | Kilowant",
        component: SellerAccountComponent
    },
    {
        path: "seller/my-account/onboarding",
        title: "Supplier Setup | Kilowant",
        component: SellerAccountComponent
    },
    {
        path: "seller/company/utilities",
        title: "Utilities | Kilowant",
        component: SellerUtilitiesComponent
    },
    {
        path: "seller/company/utilities/:action",
        title: "Utilities | Kilowant",
        component: SellerUtilitiesComponent
    },
    {
        path: "seller/terms",
        title: "Supplier Terms | Kilowant",
        component: SellerTermsListComponent
    },
    {
        path: "seller/terms/:action",
        title: "Supplier Terms | Kilowant",
        component: SellerTermsListComponent
    },
    {
        path: "seller/sell-offer/bulk-import",
        title: "Bulk Import | Kilowant",
        component: SellerBulkImportComponent
    },
    {
      path: "seller/priceplans/verify/:id",
      title: "Verify Price Plan | Kilowant",
        component: SellerVerifyContractComponent
    },
    {
      path: "seller/priceplans/view/:id",
      title: "View Price Plan | Kilowant",
        component: SellerViewContractComponent
    },
    {
        path: "seller/fees",
        title: "Fees | Kilowant",
        component: SellerFeesComponent
    },
    {
        path: "seller/batch-export",
        title: "Batch Export | Kilowant",
        component: SellerBatchExportListComponent
    },
    {
        path: "buy-offer/list",
        title: "Buy Offers | Kilowant",
        component: BuyOfferListComponent
    },
    {
        path: "buy-offer/edit/:id",
        title: "Edit Buy Offer | Kilowant",
        component: BuyOfferListComponent
    },
    {
        path: "buy-offer/details/:id",
        title: "Buy Offer Details | Kilowant",
        component: BuyOfferDetailsComponent
    },
    {
        path: "buy-offer/add",
        title: "Add Buy Offer | Kilowant",
        component: BuyOfferAddComponent
    },
    {
        path: "sell-offer/details/:id/:accountId",
        title: "Sell Offer Details | Kilowant",
        component: SellOfferDetailsComponent
    },
    {
      path: "view-priceplan/:id",
      title: "My Price Plan | Kilowant",
        component: ViewContractComponent
    },
    {
      path: "view-existing-priceplan/:id",
      title: "My Price Plan | Kilowant",
        component: ViewContractComponent
    },
    {
        path: "admin-kilowant-area",
        title: "Admin | Kilowant",
        loadChildren: () => import("./admin/admin.module").then(m => m.AdminModule)
    },
    //AFFILIATES SECTION START
    {
        path: "msashin",
        title: "Kilowant...energy at the price you want",
        component: HomeComponent
    },
    {
        path: "arandall",
        title: "Kilowant...energy at the price you want",
        component: HomeComponent
    },
    {
        path: "pfenton",
        title: "Kilowant...energy at the price you want",
        component: HomeComponent
    },
    {
        path: "tommyd",
        title: "Kilowant...energy at the price you want",
        component: HomeComponent
    },
    {
        path: "ctk",
        title: "Kilowant...energy at the price you want",
        component: HomeComponent
    },
    {
        path: "bfain",
        title: "Kilowant...energy at the price you want",
        component: HomeComponent
    },
    {
        path: "hungryhaven",
        title: "Kilowant...energy at the price you want",
        component: HomeComponent
    },
    {
        path: "easyclean",
        title: "Kilowant...energy at the price you want",
        component: HomeComponent
    },
    {
        path: "myoung",
        title: "Kilowant...energy at the price you want",
        component: HomeComponent
    },
    {
        path: "SRICC",
        title: "Kilowant...energy at the price you want",
        component: HomeComponent
    },
    {
        path: "GNCC",
        title: "Kilowant...energy at the price you want",
        component: HomeComponent
    },
    {
        path: "CRICC",
        title: "Kilowant...energy at the price you want",
        component: HomeComponent
    },
    {
        path: "RIFDA",
        title: "Kilowant...energy at the price you want",
        component: HomeComponent
    },
    {
        path: "zachbanas",
        title: "Kilowant...energy at the price you want",
        component: HomeComponent
    },
    //AFFILIATES SECTION END
    {
        path: "",
        title: "Kilowant...energy at the price you want",
        component: HomeComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        initialNavigation: "enabledBlocking"
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
